<template>
  <div class="modal fade" id="delivery-product-add-modal" role="dialog" @click="$emit('close')" :style="{ 'z-index': zIndex || 1050 }">
    <div class="modal-dialog modal-xl" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="panel products-table" ref="deliveryProductModal" style="position: relative">
            <table-delivery-product-add
              :url="'/Delivery/product-available'"
              :extraUrl="['Product/get-image-name']"
              :extraUrlMode="true"
              :columns="deliveryProductColumns"
              :isSearchable="true"
              :needExtraData="true"
              :loadingTableMode="true"
              :clientMode="true"
              :checkedItems="checkedItems"
              :isShowBtnBulkCreate="true"
              :selectedProducts="deliverySelectedProducts"
              ref="deliveryProductAddTable"
              @countData="countData = $event"
              @extraData="extraData = $event"
              @keyword="onHandleSearch"
              @zIndex="zIndex = $event"
              @checkBoxAll="checkBoxAll"
              @bulkAdd="bulkAddProducts"
              @onHandleReload="onHandleReload"
            >
              <template slot="checkBoxAll" slot-scope="props">
                <input type="checkbox" :value="props.rowData.asin" v-model="checkedItems" @change="refreshCheckAll">
              </template>
              <template slot="status" slot-scope="props">
                <span>{{ props.rowData.status_str }}</span>
              </template>
              <template slot="image" slot-scope="props">
                <loading-block :value="props.rowData.image" type="image">
                  <img :src="prepareImgSrc(props.rowData.image)" class="product-img"/>
                </loading-block>
              </template>
              <template slot="productName" slot-scope="props">
                <loading-block :value="props.rowData.itemName" type="string">
                  <a class="text--underline" :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin" target="_blank">
                    {{props.rowData.itemName}}
                  </a>
                </loading-block>
              </template>
              <template slot="action" slot-scope="props">
                <button class="btn btn-warning" @click="addProduct(props.rowData)">追加</button>
              </template>
            </table-delivery-product-add>
            <div class="row m-b-sm">
              <div class="flexbox justify-right">
                <button v-if="checkedItems.length" type="button" class="btn btn-warning btn-add-checked-all mr-r-10" @click="bulkAddProducts()">選択した商品を追加</button>
                <div data-dismiss="modal" @click="$emit('close')">
                  <button class="btn ver-middle w-120">閉じる</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableDeliveryProductAdd from '@/view/deliveryRequests/TableDeliveryProductAdd'
import LoadingBlock from '@/components/LoadingBlock'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    isLoadingButton: {
      type: Boolean
    },
    deliverySelectedProducts: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
    TableDeliveryProductAdd,
    LoadingBlock
  },
  data () {
    return {
      error: null,
      loader: null,
      zIndex: null,
      countData: null,
      extraData: null,
      keyword: null,
      deliveryProductColumns: [
        {
          title: '<input type="checkbox" id="checkbox-all">',
          name: 'checkBoxAll',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-30 th-checkbox-all',
          sortable: false
        },
        {
          title: 'ステータス',
          name: 'status',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false
        },
        {
          title: '画像',
          name: 'image',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false
        },
        {
          title: 'ASIN',
          name: 'asin',
          cellClass: 'text-center',
          headerClass: 'w-150'
        },
        {
          title: '商品名',
          name: 'productName',
          cellClass: 'text-left',
          customCell: true,
          headerClass: 'product-name'
        },
        {
          title: '',
          name: 'action',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-75',
          sortable: false
        }
      ],
      checkedItems: []
    }
  },
  computed: {
    ...mapGetters({
      isShowModal: 'getIsShowModal'
    })
  },
  watch: {
    isShowModal (newVal, oldVal) {
      if (!newVal && this.zIndex) {
        this.zIndex = null
      }
    },
    countData (newVal, oldVal) {
      this.$emit('checkAvailableItem', newVal, this.keyword)
    },
    keyword (newVal, oldVal) {
      this.$emit('checkAvailableItem', this.countData, newVal)
    },
    isShow (newVal) {
      if (!newVal && !this.isLoadingButton) {
        this.$refs.deliveryProductAddTable.reload(false, false, false, true)
      }
    }
  },
  created () {
    this.loader = this.$loading.show()
  },
  mounted () {
    $('#delivery-product-add-modal').modal('show')
    this.$events.listen('done', (url) => {
      url === '/Delivery/product-available' && this.loader && this.loader.hide()
    })
  },
  methods: {
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    addProduct (product) {
      this.$emit('handleSelectedProduct', product)
      this.$refs.deliveryProductAddTable.handleData(product, 'delete')
      this.checkedItems = this.checkedItems.filter(checkedItemAsin => checkedItemAsin !== product.asin)

      let logParams = {
        name: eventCode.delivery_requests.delivery_request_registration_tab.select_product_modal.click_add_button,
        properties: {
          asin: product.asin
        }
      }
      EventService.postTrackLog(logParams)
    },
    bulkAddProducts () {
      let selectedProducts = []
      this.$refs.deliveryProductAddTable.pageData.filter((product) => {
        if (this.checkedItems.includes(product.asin)) {
          selectedProducts.push(product)
        }
      })

      let logParams = {
        name: eventCode.delivery_requests.delivery_request_registration_tab.select_product_modal.click_add_all_button,
        properties: {
          asins: this.checkedItems
        }
      }
      EventService.postTrackLog(logParams)

      this.$refs.deliveryProductAddTable.handleData(this.checkedItems, 'deleteAll')
      this.checkAll = false
      this.checkedItems = []
      this.$emit('handleSelectedProducts', selectedProducts)
      this.$emit('close')
    },
    onHandleReload () {
      let logParams = {
        name: eventCode.delivery_requests.delivery_request_registration_tab.select_product_modal.click_reload_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.$emit('toggleButton', true)
      this.$refs.deliveryProductAddTable.reload(true)
    },

    onHandleSearch (keywordValue) {
      this.keyword = keywordValue
      let logParams = {
        name: eventCode.delivery_requests.delivery_request_registration_tab.select_product_modal.click_search_button,
        properties: {
          keyword: keywordValue
        }
      }
      EventService.postTrackLog(logParams)
    },
    refreshCheckAll () {
      const items = this.$refs.deliveryProductAddTable.pageData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    checkBoxAll (value) {
      const items = this.$refs.deliveryProductAddTable.pageData
      this.checkAll = value
      this.checkedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          _self.checkedItems.push(item.asin)
        })
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
#delivery-product-add-modal /deep/ .box-base-table-search {
  display: block;
  justify-content: unset;
  align-items: unset;
  flex-wrap: unset;
}
#delivery-product-add-modal /deep/ .box-base-table-search .search-multiple {
  flex-grow: unset;
  margin-right: unset;
  display: flex;
  align-items: center;
}
#delivery-product-add-modal /deep/ .box-base-table-search .search-multiple input {
  margin-right: 30px;
}
#delivery-product-add-modal /deep/ .th-checkbox-all {
  padding: 6px;
  position: relative;
}
#delivery-product-add-modal /deep/ .th-checkbox-all input {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
}
#delivery-product-add-modal /deep/ .row {
  margin-right: 0px;
  margin-left: 0px;
}
@media (max-width: 1200px) {
  #delivery-product-add-modal /deep/ .table-wrapper {
    overflow-x: auto;
  }
  #delivery-product-add-modal /deep/ .table-wrapper .table {
    width: max-content;
    max-width: max-content;
  }
  #delivery-product-add-modal /deep/ .product-name {
    width: 500px;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search {
    display: block;
    justify-content: unset;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block {
    display: flex;
    margin-bottom: 10px;
    margin-right: 0;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block label {
    width: 68px;
    margin-right: 0;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block input[name="detail"] {
    width: 184px;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block select[name="mallCode"] {
    width: 184px;
  }
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
    margin-left: 68px;
  }
}
@media (min-width: 1200px) {
  #delivery-product-add-modal /deep/ .box-base-table-search .sale-detail-search {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/DeliveryProductAdd.vue